import React from "react";
import '../styles/style.css';
import { credentials, education } from '../data/portfolio';

function Education() {
    const educationTimeline = [...education, ...credentials].sort((a, b) => Number(b.year) - Number(a.year));

    return (
        <section id="education-section" className="section-wrap education-section">
            <div className="education-panel">
                <div className="education-copy">
                    <p className="eyebrow">Education</p>
                    <h2>Formal foundation, applied through product work.</h2>
                    <p>
                        Graduate engineering study, highest-honor undergraduate work, design training, and cloud fundamentals behind the practice.
                    </p>
                </div>

                <div className="education-track" aria-label="Education and credentials">
                    {educationTimeline.map((item) => (
                        <article className={`education-card ${item.name ? 'credential-card' : ''}`} key={`${item.year}-${item.degree || item.name}`}>
                            <span>{item.year}</span>
                            <div>
                                <h3>{item.degree || item.name}</h3>
                                <p>{item.school || item.note}</p>
                                {item.distinction && <strong className="education-badge">{item.distinction}</strong>}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Education;
